import { useState } from 'react'

// -------------------- CUSTOM TOGGLE HOOK -------------------- //
const useToggle = () => {
  const [isToggle, setIsToggle] = useState(false)

  const isToggleHandler = () => {
    setIsToggle(prevState => !prevState)
  }

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      setIsToggle(false)
    }
  })

  return {
    isToggle,
    isToggleHandler
  }
}

export { useToggle }
